import { createActions } from 'reduxsauce';

export interface IUserState {
  data: IUserData;
  // 0 is the super-admin "ALL clients" sentinel; null means no client resolved yet. The request layer omits client_id for both.
  clientID: number | null;
  clients: { id: number; name: string }[];
  dates: {
    start: string;
    end: string;
  };
  isLoading: boolean;
  error: string;
}
export interface IUserData {
  name: string;
  client_name: string;
}

export interface UserTypes {
  USER: 'USER';
  USER_START: 'USER_START';
  USER_SUCCESS: 'USER_SUCCESS';
  USER_ERROR: 'USER_ERROR';
  USER_CLIENT_ID: 'USER_CLIENT_ID';
  USER_CLIENTS: 'USER_CLIENTS';
  USER_DATES: 'USER_DATES';
  USER_CLEAN_UP: 'USER_CLEAN_UP';
}

const { Types, Creators } = createActions<UserTypes>({
  user: ['data'],
  userStart: null,
  userSuccess: ['data'],
  userError: ['error'],
  userClientID: ['data'],
  userClients: ['data'],
  userCleanUp: null,
});

export { Types };

export default Creators;
